import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { BehaviorSubject, of } from "rxjs";
import { catchError, map, switchMap, take, tap } from "rxjs/operators";
import { Vault } from "src/app/model/vault/vault";
import { SellRequest } from "src/app/model/shop/sell-request";
import { ServerType } from "src/service/app-init.service";
import { RestApiService } from "src/service/rest-api.service";
import { PriceService } from "../price/price.service";
import { VaultActionButton } from "src/app/model/vault/vault-action-button";
import { WithdrawVaultRequest } from "src/app/model/vault/withdraw-vault-request";
import { BasketElement } from "src/app/model/shop/basket-element";
import { Product } from "src/app/model/price/product";
import { UserService } from "src/service/user.service";

@Injectable({
  providedIn: "root",
})
export class VaultService implements Resolve<any> {
  constructor(
    private restApiService: RestApiService,
    private priceService: PriceService,
    private userService: UserService
  ) {}

  endpoint = "vault/";
  sellRequest = new BehaviorSubject<SellRequest>(null);
  selectedVaultItem = new BehaviorSubject<Vault>(null);
  selectedVaultItemProduct = new BehaviorSubject<any>(null);
  vaultAction = new BehaviorSubject<VaultActionButton>(null);
  vaultList = new BehaviorSubject<Vault[]>(null);
  withdrawVaultRequest = new BehaviorSubject<any>(null);
  basketElements = new BehaviorSubject<[BasketElement]>(null);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.getVault();
  }

  refreshSellRequest(data) {
    this.sellRequest.next({ ...this.sellRequest.value, ...data });
  }

  getVault() {
    return this.restApiService.get(ServerType.WALLET, this.endpoint).pipe(
      map((vaultList: any[]) => {
        return vaultList.map((vault) => {
          if (vault.goldCard) {
            const relatedGoldCard = this.priceService.goldCardList.value.find(
              (item) => item.id == vault.productId
            );

            return {
              ...vault,
              ...relatedGoldCard,
            };
          } else {
            const relatedProduct = this.priceService.productList.value.find(
              (item) => item.id == vault.productId
            );

            return {
              ...vault,
              ...relatedProduct,
            };
          }
        });
      }),
      tap((vaultList) => this.vaultList.next(vaultList)),
      catchError((error) => of(true))
    );
  }

  selectVaultItem(vault: Vault) {
    this.selectedVaultItem.next(vault);

    return of(vault.goldCard).pipe(
      switchMap(goldCard=>{
        if(goldCard){
          return this.priceService.getGoldCardById(vault.productId)
        }else{
          return this.priceService.getProductById(vault.productId)
        }
      }),
      tap(vaultProduct=>this.selectedVaultItemProduct.next(vaultProduct))
    )
/*
    return this.priceService
      .getProductById(vault.productId)
      .pipe(
        tap(product=>console.log(product)),
        tap((vaultProduct) => this.selectedVaultItemProduct.next(vaultProduct))
      ); */
  }

  getVaultByProductId(productId:string){
    return this.vaultList.pipe(
      take(1),
      map(list=>list.find(item=>item.productId == productId))
    )
  }

  getVaultShipmentCost(afterPurchaseType) {
    return this.restApiService.post(
      ServerType.WALLET,
      "product/shipment-cost",
      {
        afterPurchaseType,
        ...this.withdrawVaultRequest.value,
        priceJwt: this.priceService.priceJwt.value,
        country: this.userService.user.value.country,
      }
    );
  }

  getVaultSubscriptionCost(basketElements) {
    return this.restApiService.post(
      ServerType.WALLET,
      this.endpoint + "get-cart-vault-subscription-amount",
      {basketElements,  priceJwt: this.priceService.priceJwt.value,}
    );
  }

  refreshWithdrawVaultRequest(basketElements: BasketElement) {
    this.withdrawVaultRequest.next({ basketElements: [basketElements] });
    this.basketElements.next([basketElements]);
  }

  withdrawVault(withdrawVaultRequest: WithdrawVaultRequest) {
    return this.restApiService.post(
      ServerType.WALLET,
      this.endpoint + "shipment",
      withdrawVaultRequest
    );
  }
}
